<template>
  <div>
    <div ref="panzoomSlot" @click="handleClick">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import panzoom from 'panzoom';

const SINGLE_CLICK_COUNT = 1;
const DOUBLE_CLICK_COUNT = 2;

export default {
  props: {
    options: {
      default: null,
      type: Object
    },
    preventDefault: {
      default: true,
      type: Boolean
    },
    isZoomed: {
      default:false,
      type: Boolean
    }
  },
  data:function () {
    return {
      clickCount: 0,
      clickTimer: null
    }
  },

  mounted() {
    const defaultOptions = {
      autocenter: true,
      bounds: true,
      onTouch(e) {
        return this.preventDefault;
      }
    };

    this.panzoom = panzoom(this.$refs.panzoomSlot, Object.assign({}, defaultOptions, this.options || {}));

    this.panzoom.on('zoom', (e) => this.$emit('zoom', e));
  },

  methods: {
    /*
      This method checks if a click was a double click or a single click.
      If it was a single click, we do not do anything and just reset the clickCount.
      Doing this because Vue doesn't seem to have a method to handle double clicks
      and will zoom out only on a double click
    */
    handleClick() {
      this.clickCount += 1;
      if (this.clickCount === SINGLE_CLICK_COUNT) {
        this.clickTimer = setTimeout(() => {
          this.clickCount = 0
        }, 400)
      } else if (this.clickCount === DOUBLE_CLICK_COUNT) {
        this.$emit('trackEvents','New_Gallery_Double_Click_Zoom');
        clearTimeout(this.clickTimer);
        this.clickCount = 0
        // If we are zoomed in, we are already at max magnication so just zoom out
        if (this.isZoomed) {
          setTimeout(() => {
            this.$emit('zoomout');
          }, 100)
        }
      }
    },
    smoothZoomAbs(x, y, scale) {
      if(this.panzoom) {
        this.panzoom.smoothZoomAbs(x, y, scale);
      }
    }
  }
};
</script>

<style>

</style>
